import type { JSX } from "react";
import type { CommonNavItemProps } from "../common-nav-item-props";
import type { NavItemProps } from "../nav-item";
import { NavItemMenuCollapsed } from "./nav-item-menu-collapsed"; // eslint-disable-line import/no-cycle
import { NavItemMenuInline } from "./nav-item-menu-inline";


export type NavItemMenuProps = CommonNavItemProps & {
	kind: "menu";
	items: readonly Exclude<NavItemProps, NavItemMenuProps>[];
};
export const NavItemMenu = (props: NavItemMenuProps): JSX.Element => {
	return props.collapsed
		? <NavItemMenuInline { ...props }/>
		: <NavItemMenuCollapsed { ...props }/>;
};